export default "__VITE_ASSET__BB$BO2Ys__"